// extracted by mini-css-extract-plugin
export var AdBlocks = "MPUBanner-module--AdBlocks--70c91";
export var HasDMPU = "MPUBanner-module--HasDMPU--641f7";
export var MPU = "MPUBanner-module--MPU--9fccb";
export var Sticking = "MPUBanner-module--Sticking--893c0";
export var Unstuck = "MPUBanner-module--Unstuck--3e0c8";
export var Wrapper = "MPUBanner-module--Wrapper--1aa54";